export const CFaqSliderFragments = {
  field: `
    fragment faqSlider on faqVideoSlider_MatrixField {
      ... on faqVideoSlider_block_Entry {
        __typename
        idName
        heading
      }
      ... on faqVideoSlider_faqVideos_Entry {
        __typename
        primaryCopy
        secondaryCopy
        video {
          title
          slug
          url
          embeddedAsset {
            title
            description
            url
            type
          }
        }
      }
    }
  `,
};
